import { Box, Typography } from '@mui/material';
import { TextWithLimitedWidth } from 'components/SlideGroups/components/TextWithLimitedWidth';
import { ToggleButtons } from 'components/AntibodiesList/ToggleButtons';
import { useAntibodyDetailsStyles } from 'components/AntibodiesList/styles';

export const DetailsHeader = ({
  selectedAntibody,
  selectedViewMode,
  setSelectedViewMode,
  thumbnail,
  isAntibodyDeepLink = false,
  isPublicCatalog = false,
}) => {
  const handleToggle = (event, newSelected) => {
    setSelectedViewMode(newSelected);
  };

  const { classes } = useAntibodyDetailsStyles();

  // Exactly one h1, and only on the page rather than in a modal: the antibody name when a
  // URL names one, otherwise the catalog label — never both, and never an empty heading on
  // a deep link that resolved to nothing. The order form and slide-metadata modals mount
  // this component too, and a document-level heading there would describe a different page.
  const antibodyName = selectedAntibody?.display_name;
  const isAntibodyHeading = isAntibodyDeepLink && !!antibodyName;
  const isCatalogHeading = isPublicCatalog && !isAntibodyHeading;

  return (
    <Box mb={1} className={classes.header}>
      <Box className={classes.titleContainer}>
        <Typography
          className={classes.title}
          component={isCatalogHeading ? 'h1' : 'p'}
        >
          IHC Antibody Catalog
        </Typography>
        <Box className={classes.subTitle}>
          <TextWithLimitedWidth
            component={isAntibodyHeading ? 'h1' : 'p'}
            containerClass={classes.truncate}
            value={antibodyName}
            tooltipPlacement={'bottom'}
          />
        </Box>
      </Box>
      {thumbnail && (
        <ToggleButtons
          handleToggle={handleToggle}
          selected={selectedViewMode}
          classes={classes}
        />
      )}
    </Box>
  );
};
